import React from "react";
import { useLocation } from "react-router-dom";
import { X, Gift } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const HIDDEN_PATHS = ["/login", "/register", "/inregistrare", "/reset-parola", "/cont", "/checkout", "/admin"];

export default function WelcomePopup() {
    const location = useLocation();
    const [data, setData] = React.useState(null);
    const [email, setEmail] = React.useState("");
    const [closed, setClosed] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);

    const suppressed = HIDDEN_PATHS.some(p => location.pathname === p || location.pathname.startsWith(p + "/"));

    React.useEffect(() => {
        if (suppressed) return;
        if (localStorage.getItem("st_welcome_dismissed")) return;
        const t = setTimeout(() => {
            api.get("/promotions/welcome").then(r => { if (r.data.enabled) setData(r.data); }).catch(() => {});
        }, 5000);
        return () => clearTimeout(t);
    }, [suppressed]);

    // Close without persisting — popup will show again on next visit
    const closeTemp = () => setClosed(true);
    // Permanent dismiss — popup won't show again
    const dismissForever = () => {
        localStorage.setItem("st_welcome_dismissed", "1");
        setClosed(true);
    };

    const subscribe = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
            await api.post("/newsletter/subscribe", { email });
            toast.success("Verifică emailul pentru codul de reducere!");
            dismissForever();
        } catch { toast.error("Eroare la abonare"); }
        finally { setSubmitting(false); }
    };

    if (!data || closed || suppressed) return null;

    const valueLabel = data.type === "percent" ? `${data.value}%` : `${data.value} RON`;

    return (
        <div className="fixed inset-0 z-[200] flex items-end sm:items-center justify-center sm:p-4 bg-foreground/60 backdrop-blur-sm" data-testid="welcome-popup">
            <div className="card-soft max-w-md w-full p-0 overflow-hidden rounded-t-2xl sm:rounded-2xl rounded-b-none sm:rounded-b-2xl">
                <div className="bg-primary text-primary-foreground p-6 relative">
                    <button onClick={closeTemp} aria-label="Închide" className="absolute top-3 right-3 text-primary-foreground/80 hover:text-primary-foreground" data-testid="welcome-popup-close"><X className="h-5 w-5" /></button>
                    <Gift className="h-10 w-10 mb-3" />
                    <h3 className="font-heading text-2xl mb-1">{data.title}</h3>
                    <p className="text-sm opacity-90">{data.subtitle}</p>
                </div>
                <div className="p-6 text-center">
                    <div className="overline mb-2">Primești reducere de</div>
                    <div className="font-heading text-5xl text-primary mb-1">{valueLabel}</div>
                    <p className="text-xs text-muted-foreground mb-4">la prima comandă — îți trimitem codul pe email</p>
                    <form onSubmit={subscribe} className="space-y-2">
                        <input type="email" required placeholder="Emailul tău" value={email} onChange={(e) => setEmail(e.target.value)} className="input-soft" data-testid="welcome-email" />
                        <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="welcome-subscribe">{submitting ? "Se trimite..." : "Trimite-mi codul pe email"}</button>
                        <button type="button" onClick={dismissForever} className="text-xs text-muted-foreground hover:underline" data-testid="welcome-popup-decline">Nu mulțumesc</button>
                    </form>
                </div>
            </div>
        </div>
    );
}
